import * as React from 'react'
import { Skeleton } from '@components'

const AddressItemLoader: React.FC = () => {
    return (
        <Skeleton className="!h-[80px] w-full rounded-[20px] bg-semantic-background-primary" />
    )
}
export default AddressItemLoader
